import { Alert, AlertTitle } from '@mui/material';
import { closeSnackbar } from 'notistack';
import React from 'react';
import { NotificationTypes, PinnacleNotificationCompleteProps } from '../PinnacleSnackbarProvider.types';

declare module 'notistack' {
  interface VariantOverrides {
    PinnacleNotificationComplete: {
      details: string;
      title?: string;
      type: NotificationTypes;
    }
  }
}

export const PinnacleNotificationComplete = React.forwardRef<HTMLDivElement, PinnacleNotificationCompleteProps>(
  (props, ref) => {
    const {
      id, title, details, type,
    } = props;

    return (
      <Alert
        severity={type}
        ref={ref}
        role="alert"
        onClose={() => closeSnackbar(id)}
        sx={{
          color: 'rgba(255, 255, 255, 1)',
          backgroundColor:
            type === 'success'
              ? 'var(--alert-success)'
              : type === 'error'
                ? 'var(--alert-error)'
                : type === 'info'
                  ? 'var(--alert-info)'
                  : undefined,
        }}
      >
        {title && <AlertTitle sx={{ mt: 0 }}>{title}</AlertTitle>}
        {details}
      </Alert>
    );
  },
);

export default PinnacleNotificationComplete;
